__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-bob/f48b488e08cbcd54201a4804aefb5f0bb7fa2274ced902d1f58d6ea3/";